import React from "react";
import { FaUserEdit } from "react-icons/fa";
import { HiOutlineUserGroup } from "react-icons/hi";
import styles from "../styles/campaignNotifications.module.scss";

export default function CampaignRowActions({ canEdit, onEdit, onUsers }) {
  return (
    <div className={styles.actions}>
      <button
        type="button"
        className={styles.actionBtn}
        onClick={onEdit}
        disabled={!canEdit}
      >
        <FaUserEdit />
        <span>Edit</span>
      </button>
      <button
        type="button"
        className={styles.actionBtn}
        onClick={onUsers}
        title="Open campaign users"
      >
        <HiOutlineUserGroup />
        <span>Users</span>
      </button>
    </div>
  );
}
